import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import EnhancedTab from '../../../../lib/designSystem/TabSimulation';
import ExecutedCreditLineEvaluations from './CreditLine';

const companyTabs = [
  {
    label: 'Línea de crédito',
    component: <ExecutedCreditLineEvaluations />,
    path: 'shared/creditLineShared',
    subPage: 'creditLineShared',
    index: 0,
  },
];

const RiskTab: React.FC = () => {
  const { subPage } = useParams<{
    subPage: string;
  }>();
  const navigate = useNavigate();

  const [startValue, setStartValue] = useState(0);

  const setUpTabs = () => {
    const startValueFind = companyTabs.findIndex(
      (x: any) => x.subPage === subPage,
    );
    if (startValueFind !== -1) return setStartValue(startValueFind);
    setStartValue(0);
  };

  const handleNavigation = (index: number) => {
    navigate(`/creditHubPro/executed/${companyTabs[index].path}`);
  };

  useEffect(() => {
    setUpTabs();
  }, []);

  return (
    <EnhancedTab
      startValue={startValue}
      tabs={companyTabs}
      onTabChange={handleNavigation}
    />
  );
};

export default RiskTab;
